// eslint-disable-next-line no-use-before-define
import React from 'react';
import {
  connect,
  useDispatch
} from 'react-redux';
import { Redirect, Route } from 'react-router';
import { RootStateType } from '../redux-store/reducers';
import { logout } from '../redux-store/actions/auth';
import usePageTitle from '../hooks/usePageTitle';

export type AuthRoutePropsType = {
  path: string;
  component: React.ComponentType<any>;
  isLoggedIn: boolean;
  exact?: boolean;
  role?: string;
  acceptedRoles?: string[];
  title?: string;
};

function PageTitleSetter({ title }: { title: string }) {
  usePageTitle(title);
  return null;
}

function ProtectedRoute({
  component: Component,
  isLoggedIn,
  role = '',
  acceptedRoles,
  title,
  ...rest
}: // eslint-disable-next-line no-undef
  AuthRoutePropsType): JSX.Element {
  const dispatch = useDispatch()
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          acceptedRoles?.includes(role) ? (
            <>
              {title && <PageTitleSetter title={title} />}
              <Component {...rest} />
            </>
          ) : (
            <Route
              path="*"
              render={() => {
                return (
                  <>
                    <PageTitleSetter title="Unauthorized" />
                    <p>You are not authorized to view this page</p>
                    <button onClick={() => dispatch(logout())}>Logout</button>
                  </>
                );
              }}
            />
          )
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: location } }} />
        )
      }
    />
  );
}
export default connect(
  ({ auth }: RootStateType) => ({ isLoggedIn: !!auth.token, role: auth.role }),
  {}
)(ProtectedRoute);
